export enum ApplicationTabEnum {
    PendingApplicationsSubmittedDirectlyBranch = 1,
    PendingApplicationsPulledFromMarketPlace = 2,
    MarketPlaceApplications = 3,
    SanctionedApplications = 4,
    ReturnedApplications = 5,
}


export enum ModuleEnum {
    BankList,
    BranchList,
    UserList,
    UserLevelList,
    ReportsList,
    BankLoanApplicationMarketList,
    BankLoanDisbursedMarketList,
    BankLoanPendingMarketList,
    GeoLoanApplicationMarketList,
    GeoLoanDisbursedMarketList,
    GeoLoanPendingMarketList,
    GeoLoanApplicationList,
    GeoLoanDisbursedList,
    GeoLoanPendingList,
    SHGWiseReportList,
    SHGWiseMarketList,
    MarketWiseReportList,
    DataArchivesList,
    ResourceCenterList,
    HomePageList,
    SyncDataList,
    SyncSummaryList,
    SyncBranchesList,
    HomeBranchesList,
    DownloadCSVList
}